export enum CallStatus {
    INITIAL = 'INITIAL',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    NOT_FOUND = 'NOT_FOUND',
    ERROR = 'ERROR',
}
